export default __webpack_public_path__ + "static/media/logo_white.9a37959f.png";